/* eslint-disable import/no-cycle */
import {decorate, observable} from 'mobx';
import * as moment from 'moment';

export class PerformanceAnalysisStore {
  filter = {
    timeWindow: [moment().startOf('day'), moment().add(1, 'day').startOf('day')],
  };

  setFilterValue = (key, value) => {
    if (value !== undefined) {
      this.filter[key] = value;
    }
  };
}

decorate(PerformanceAnalysisStore, {
  filter: observable,
});
